function callback(array, iteratee) {
	return array.reduce((accumulator, element) => {
		if (element) {
			if (accumulator.length === 0) {
				accumulator.push(element)
			} else {
				let found = false
				for (let x of accumulator) {
					if (iteratee(x) === iteratee(element)) {
						found = true
						break
					}
				}
				if (!found) {
					accumulator.push(element)
				}
			}
		}
		return accumulator
	}, [])
}

export default function uniqBy(array, iteratee) {
	if (array) {
		if (Array.isArray(array) && Array.length > 0) {
			if (iteratee && iteratee.constructor === Function) {
				return callback(array, iteratee)
			} else if (iteratee && iteratee.constructor === String) {
				return callback(array, ele => ele[iteratee])
			} else {
				return [...new Set(array)]
			}
		}
	}
	return []
}
